export const enum INFOCARD_ACTION_TYPE {
  Dismiss = 'dismiss',
  Email = 'email',
  Flow = 'flow',
  Giving = 'giving',
  Page = 'page',
  Prayer = 'prayer',
  Url = 'url',
}
